import { Box, HStack } from "@chakra-ui/react";

const EditorDots = () => {
  return (
    <HStack height={"1rem"} justifyContent={"flex-end"}>
      <Box
        borderRadius={"full"}
        height={".6rem"}
        width={".6rem"}
        bg={"red.500"}
      ></Box>
      <Box
        borderRadius={"full"}
        height={".6rem"}
        width={".6rem"}
        bg={"yellow.500"}
      ></Box>
      <Box
        borderRadius={"full"}
        height={".6rem"}
        width={".6rem"}
        bg={"green.500"}
      ></Box>
    </HStack>
  );
};

export default EditorDots;
